import { useVsiAppContext } from "../../stores/VsiApp";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Input, Row, UncontrolledTooltip } from "reactstrap";
import { VsiLgText, VsiMedLabel, VsiMedText } from "../../styled/App.styled";
import { withErrorBoundary } from "../../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../../boundaries/GeneralErrorBoundary";

function CustomResourceCard ({ resourceType, activeCustomPlan, changeDataWithCustomResource, workloadMetrics, modelingContext = 'cluster' }) {
	const { theme } = useVsiAppContext();
	
	const [vm, setVm] = useState(activeCustomPlan.vm ?? 0);
	const [cpu, setCpu] = useState(activeCustomPlan.cpu ?? 0);
	const [mem, setMem] = useState(activeCustomPlan.mem ?? 0);
	const [disk, setDisk] = useState(activeCustomPlan.disk ?? 0);
	const [cost, setCost] = useState(activeCustomPlan.cost ?? 0);

	const onChange = e => {
		const { name, value } = e.target;
		
		// if (value >= 0) {
			if (name === "vm") {
				setVm(parseInt(value));
				if (resourceType === 'workload') {
					const {
						average_vm_cpu_size,
						average_vm_memory_size,
						average_vm_disk_size,
						vm_avg_cost
					} = workloadMetrics;

					setCpu(parseFloat((value * (average_vm_cpu_size ?? 0)).toFixed(1) ?? cpu));
					setMem(parseFloat((value * (average_vm_memory_size ?? 0)).toFixed(2) ?? mem));
					setDisk(parseFloat((value * (average_vm_disk_size ?? 0)).toFixed(2) ?? disk));
					setCost(parseFloat((value * vm_avg_cost).toFixed(2) ?? cost));
				}
				
			} else if (name === "cpu") {
				setCpu(parseFloat(value));
			} else if (name === "mem") {
				setMem(parseFloat(value));
			} else if (name === "disk") {
				setDisk(parseFloat(value));
			} else if (name === "cost") {
				setCost(parseFloat(value));
			}
		// }
	}
	
	const onApplyClick = () => {
		changeDataWithCustomResource({
			vm,
			cpu,
			mem,
			disk,
			cost,
		})
	}

	useEffect(() => {
		setVm(activeCustomPlan.vm ?? 0);
		setCpu(activeCustomPlan.cpu ?? 0);
		setMem(activeCustomPlan.mem ?? 0);
		setDisk(activeCustomPlan.disk ?? 0);
		setCost(activeCustomPlan.cost ?? 0);
	}, [activeCustomPlan]);

	return (
		<Card color={theme} className={"my-2"}>
			<CardHeader>
				<Row>
					<Col xs={9}>
						<VsiLgText textAlign={"left"} style={{ fontStyle: 'italic' }}>* Custom Resource <VsiMedText>({resourceType})</VsiMedText></VsiLgText>
					</Col>
					<Col xs={3} className={"d-flex flex-row justify-content-end"}>
						<Button color={'primary'} id="add-to-chart" onClick={onApplyClick}>
							<i className={"fa-sharp fa-solid fa-plus"}/>
						</Button>
						<UncontrolledTooltip placement={"bottom"} target={"add-to-chart"}>
              Add custom resource
            </UncontrolledTooltip>
					</Col>
				</Row>
			</CardHeader>
			<CardBody>
				<Row>
					{resourceType === 'workload' ? (
						<Col xs={modelingContext === 'cluster' ? 6 : 4} className={"d-flex flex-column justify-content-between"}>
							<VsiMedLabel textAlign={"left"}># VMs</VsiMedLabel>
							<Input value={vm}
							       type={"number"}
							       onChange={onChange}
							       name={"vm"}/>
						</Col>
					) : null}
					{modelingContext === 'cloud' ? (
						<Col xs={6} className={"d-flex flex-column justify-content-between"}>
							<VsiMedLabel textAlign={"left"}>Cost ($)</VsiMedLabel>
							<Input value={cost}
										 type={"number"}
										 onChange={onChange}
										 name={"cost"}/>
						</Col>
					) : null}
					<Col xs={(resourceType === 'workload' && modelingContext === 'cluster') ? 6 : 4} className={"d-flex flex-column justify-content-between"}>
						<VsiMedLabel textAlign={"left"}>vCPU</VsiMedLabel>
						<Input value={cpu}
						       type={"number"}
						       onChange={onChange}
						       name={"cpu"}/>
					</Col>
					<Col xs={(resourceType === 'workload' && modelingContext === 'cluster') ? 6 : 4} className={"d-flex flex-column justify-content-between"}>
						<VsiMedLabel textAlign={"left"}>Memory (GiB)</VsiMedLabel>
						<Input value={mem}
						       type={"number"}
						       onChange={onChange}
						       name={"mem"}/>
					</Col>
					<Col className={"d-flex flex-column justify-content-between"}>
						<VsiMedLabel textAlign={"left"}>Disk (GiB)</VsiMedLabel>
						<Input value={disk}
						       type={"number"}
						       onChange={onChange}
						       name={"disk"}/>
					</Col>
				</Row>
			</CardBody>
		</Card>
	)
}

export default withErrorBoundary(CustomResourceCard, GeneralErrorBoundary);
